<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter21">
<h1><a id="page_39"></a><a href="#/003toc#ch21">Many Bean Soup</a></h1>
<p class="noindent">This hearty soup requires soaking the beans overnight and then putting everything in the slow cooker for the day. It’s a colorful, flavorful, and healthful choice for dinner, and your slow cooker makes it a no-brainer for a day when you want to come home to a bowl of comfort food. A loaf of crusty bread or freshly baked cornbread makes the perfect accompaniment.</p>
<p class="noindent">The choice of beans is up to you; it’s really more about color, texture, and the beans that you like. (You can double up on one type if that appeals.) I like to buy my beans at health food stores where they have bulk-food bins, so that I only buy what I need. Many markets sell a blend of beans for this soup, so you can keep a bag of beans in your pantry just in case of a soup emergency!</p>
<p class="noindent">¼ cup dried red beans</p>
<p class="noindent">¼ cup dried small white beans</p>
<p class="noindent">¼ cup dried pinto beans</p>
<p class="noindent">¼ cup dried kidney beans</p>
<p class="noindent">¼ cup dried cranberry beans</p>
<p class="noindent">¼ cup dried baby lima beans</p>
<p class="noindent">¼ cup dried black-eyed peas</p>
<p class="noindent">¼ cup dried green split peas</p>
<p class="noindent">¼ cup dried yellow split peas</p>
<p class="noindent">¼ cup dried red lentils</p>
<p class="noindent">¼ cup dried brown lentils</p>
<p class="noindent">1 large onion, finely chopped</p>
<p class="noindent">3 medium carrots, chopped</p>
<p class="noindent">3 stalks celery, finely chopped</p>
<p class="noindent">2 teaspoons dried thyme</p>
<p class="noindent">1 bay leaf</p>
<p class="noindent">One 15-ounce can chopped plum tomatoes, with their juice</p>
<p class="noindent">1 smoked ham hock or ham bone</p>
<p class="noindent">8 cups chicken or vegetable broth</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">soak the red, white, pinto, kidney, cranberry, lima beans, and black-eyed peas overnight in water to cover. Drain and rinse thoroughly.</p>
<p class="noindent">add the soaked beans, split peas, and lentils to the insert of a 5- to 7-quart slow cooker. Add the remaining ingredients up through the broth and stir to combine.</p>
<p class="noindent">cook on low for 8 to 10 hours, until the beans are tender and the ham is falling off the bone.</p>
<p class="noindent">remove the ham hock or bone from the soup, chop any meat, removing the fat, and return the meat to the slow-cooker.</p>
<p class="noindent">season with salt and pepper. Remove the bay leaf before serving.</p>
<p class="noindent">serves 8–10</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> slow-cooker savvy</p>
<p class="noindent">When I have ham for a holiday dinner, I will generally freeze the bone after we have cleaned off most of the meat. Then when I want to make soup, I’ll defrost it and place it in the slow cooker with the other ingredients. Ham hocks and smoked hams tend to be salty, so I recommend not salting the soup until close to the end of the cooking time.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 027-chapter21.vue?fd20889a